import React from 'react'

export default class YearMonthSelector extends React.Component {
  onMonthClick(month) {
    this.props.onMonthClick(month);
  }

  labelFor(month) {
    if (this.props.labels && this.props.labels[month]) {
      return this.props.labels[month];
    } else {
      return month;
    }
  }

  render() {
    const months = $.map(this.props.months, (month) => {
      let klass = "year-month-option";
      if (this.props.selected[month]) {
        klass += " year-month-option--selected";
      }
      return <div key={month} className={klass} onClick={this.onMonthClick.bind(this, month)}>{this.labelFor(month)}</div>
    });

    return (
      <div className="mb-2">
        <div className="d-flex justify-content-center">
          <h4 className="fw-heavy">{this.props.year}</h4>
        </div>

        <div className="year-month-grid">
          {months}
        </div>

      </div>
      );
  }
}
